
export const formatToLongDate = (inputDate) => {
    if (!inputDate || typeof inputDate !== "string") {
        return "Invalid Date Format";
    }

    const parts = inputDate.split("-");

    if (parts.length !== 3) {
        return "Invalid Date Format";
    }

    const [year, month, day] = parts.map(Number);

    const monthNames = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ];

    if (
        year < 1000 ||
        month < 1 ||
        month > 12 ||
        day < 1 ||
        day > 31
    ) {
        return "Invalid Date";
    }

    return `${monthNames[month - 1]} ${day}, ${year}`;
};




// export const formatToLongDate = (inputDate) => {
//     if (!inputDate || typeof inputDate !== "string") return "Invalid Date";

//     const parts = inputDate.split("/");
//     if (parts.length !== 3) return "Invalid Format";

//     const [month, day, year] = parts.map(Number);

//     const monthNames = [
//         "January", "February", "March", "April", "May", "June",
//         "July", "August", "September", "October", "November", "December"
//     ];

//     if (
//         year < 1000 ||
//         month < 1 || month > 12 ||
//         day < 1 || day > 31
//     ) {
//         return "Invalid Date";
//     }

//     return `${monthNames[month - 1]} ${day}, ${year}`;
// };